import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const MultiCategoryHomepageCreateEditRBAC = {
  pageID: '09d491e8ca11fb3907d5765b2a6a360c',
  elementID: {
    EditComponent: '71505a1562241f5ce3a73ab85f780ffd',
    AddComponent: 'd6fe8df27a2077d0ef78915bbf71d27e',
    View: '50efb06bb344c9bf7f4cd01670ede227',
    SaveAsDraft: '0ec95d3d6f6ee70b9f78884f0ad0bd58',
    Lanjut: '7c263831a31910e4337a2d473de5f982',
    AturPosisiComponent: 'c4062d8c28382717ed131f2e8ed496ca',
    DeleteComponent: '1cd72fb8481910e4337a1599bc861e95',
  },
} as const

export const useRBACMultiCategoryHomepageCreateEdit = createUseRBAC(
  MultiCategoryHomepageCreateEditRBAC.elementID,
)

export type UseRBACMultiCategoryHomepageCreateEditType = ReturnType<
  typeof useRBACMultiCategoryHomepageCreateEdit
>
